import LoginLayout from "../../layout/LoginLayout";
import css from "./forgotPassword.module.css";
import Input from "@/src/components/controls/Input/Input";
import { LargeBlueButton } from "@/src/components/controls/Button/Button";
import mailIcon from "@/assets/mailGray.svg";
import { useState } from "react";
import Link from "next/link";
import arrowRightYellow from "@/assets/arrowRightYellow.svg";
import { withRedux } from "@/util/reduxUtils";
import { preloadGlobalResources } from "@/util/authUtils";
import { useTranslation } from "@/util/helper";
import auth from "@/api/auth/auth";

const forgotPasswordStepKeys = {
    inputPassword: "INPUT_PASSWORD",
    checkInbox: "CHECK_INBOX"
};

const forgotPasswordSteps = {
    INPUT_PASSWORD: {
        title: "forgotPassword:forgotPassword.titleText",
        description: "forgotPassword:forgotPassword.description",
        input: ({ t, value, onChange, error }) => <Input
            wrapperClassName={css.email}
            prefix={<img src={mailIcon} />}
            name={"email"}
            info={error}
            value={value}
            onChange={(e) => {
                onChange(e.target.value)
            }}
            type={"email"}
            theme={"dark"}
            placeholder={t('forgotPassword:forgotPassword.businessEmail')}
        />,
        action: (t, isLoading) => <LargeBlueButton isLoading={isLoading} className={css.submit}>
            {t('forgotPassword:forgotPassword.action')}
        </LargeBlueButton>
    },
    CHECK_INBOX: {
        title: "forgotPassword:checkInbox.titleText",
        description: "forgotPassword:checkInbox.description",
        input: (t) => <></>,
        action: (t) => <Link href={"/login"}>
            <a className={css.loginLink}>
                <div className={css.arrow} >
                    <img src={arrowRightYellow} />
                </div>
                {t('forgotPassword:checkInbox.action')}
            </a>
        </Link>
    }
};


const Title = ({ step, t }) => {
    return <div className={css.title}>{t(forgotPasswordSteps[step].title)}</div>
};

const Description = ({ step, t }) => {
    return <div className={css.description}>{t(forgotPasswordSteps[step].description)}</div>
};

const InputField = ({ step, t, onChange, value, error }) => {
    return forgotPasswordSteps[step].input({ onChange, value, t, error })
};

const Action = ({ step, t, isLoading }) => {
    return forgotPasswordSteps[step].action(t, isLoading)
};

const ForgotPassword = () => {

    const { t } = useTranslation();

    const [step, setStep] = useState(forgotPasswordStepKeys.inputPassword);
    const [email, setEmail] = useState("");
    const [error, setError] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();

        if (email == null || email == "") {
            setError(t('errors.requiredField'))
            return
        }
        try {
            setIsLoading(true);
            await auth().resetPassword(email);
            setStep(forgotPasswordStepKeys.checkInbox);
        } catch (e) {
            setIsLoading(false);
            setError(t('errors.emailNotFound'));
        }

    };

    return <LoginLayout>
        <form className={css.wrapper} onSubmit={e => onSubmit(e)}>
            <Title step={step} t={t} />
            <Description step={step} t={t} />
            <InputField step={step} onChange={setEmail} value={email} error={error} t={t} />
            <Action step={step} t={t} isLoading={isLoading} />
        </form>

    </LoginLayout>
};

ForgotPassword.getInitialProps = async (ctx) => {
    await preloadGlobalResources(ctx);

    return {
        namespacesRequired: ["common", "forgotPassword"],
    }
};

export default withRedux(ForgotPassword);
